import { render, staticRenderFns } from "./other-channel-status.vue?vue&type=template&id=00145b39&scoped=true"
import script from "./other-channel-status.vue?vue&type=script&lang=js"
export * from "./other-channel-status.vue?vue&type=script&lang=js"
import style0 from "./other-channel-status.vue?vue&type=style&index=0&id=00145b39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00145b39",
  null
  
)

export default component.exports